import Enumerable from "linq";
import { Department } from "../../../../domain/department";
import { IHisInformationApplicable, instanceOfIHisInformationApplicable } from "../../../../domain/document/items";
import { DepartmentRelatedHisInformation } from "../../../../domain/his";
import { HisInformationTextValue } from "../../../../domain/his/HisInformationValue";
import { IDocumentEditable } from "../IDocumentEditable";

export class DepartmentRelatedHisInformationApplicator {
  constructor(private _document: IDocumentEditable) {
  }

  public apply(department: Department): void {
    const info = this.getDepartmentRelatedHisInformation(department);
    if (!info) { return; }

    for (let itemSetId = 0; itemSetId < this._document.itemSets.length; ++itemSetId) {
      const itemSet = this._document.itemSets[itemSetId];
      for (const item of itemSet.items) {
        if (!instanceOfIHisInformationApplicable(item) || !this.isEditableHisObject(item)) { continue; }
        const valueSource = Enumerable.from(info.items).firstOrDefault(i => i.name === item.hisItemParameter.key);
        if (!valueSource) { continue; }

        const valueItem = new HisInformationTextValue(item.hisItemParameter.key, [valueSource.value]);
        const cloned = item.clone() as IHisInformationApplicable;
        cloned.setHisInfoItems(valueItem, false);
        cloned.adjustObjectHeight();
        cloned.adjustFontSize();
        this._document.updateItem(cloned, {
          itemSetId,
        });
      }
    }
  }

  private getDepartmentRelatedHisInformation(department: Department): DepartmentRelatedHisInformation {
    const infos = this._document.source.hisInformation.departmentRelatedInformations;
    if (!infos) { return null; }
    
    if (department) {
      const found = Enumerable.from(infos).firstOrDefault(i => i.departmentCodes.indexOf(department.id) >= 0);
      if (found) { return found; }
    }
    return Enumerable.from(infos).firstOrDefault(i => i.isDefault);
  }

  private isEditableHisObject(item: IHisInformationApplicable): boolean {
    return item.isEditable
      && !item.isDeleted
      && item.isHisInfo
      && !!item.hisItemParameter;
  }

  public shouldUpdateDepartmentRelatedHisInformation(department: Department): boolean {
    return this.getDepartmentRelatedHisInformation(this._document.source.attributes.department) !== this.getDepartmentRelatedHisInformation(department);
  }
}
